






























































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import { ChangePassword } from '@/domain/ChangePassword'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class MemberChangePassword extends Mixins(GlobalMixin) {
  request: ChangePassword = new ChangePassword()

  /**
   * ダイアログの確定処理
   */
  onSubmit() {
    this.showLoading()
    this.usersService.changePassword(this.loginUserId, this.request)
        .then(() => {
          this.alert("パスワードを変更しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("パスワードの変更に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
  }
}
